import { useState } from 'react';
import { ALargeSmall } from 'lucide-react';
import { toast } from 'sonner';
import { getScale, applyScale, SCALES } from '../lib/uiScale';

export const UiScaleBtn = ({ t }) => {
  const [i, setI] = useState(getScale);
  const names = [t.uiN, t.uiL, t.uiXL];
  const next = () => { const n = (i + 1) % SCALES.length; applyScale(n); setI(n); toast.success(`${t.uiView}: ${names[n]}`); };
  return (
    <button className={`chip help-chip scale-chip ${i ? 'on-chip' : ''}`} data-testid="ui-scale-btn" data-scale={i} onClick={next} title={`${t.uiView}: ${names[i]}`}>
      <ALargeSmall size={16} /> <span>{names[i]}</span>
    </button>
  );
};
